import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { buildPrivacyPolicy } from "@/content/privacyPolicy";

const PAGES = {
  legal: { key: "legal_notice", label: "Informations légales", title: "Mentions légales", testid: "legal-page" },
  privacy: { key: "privacy_policy", label: "Vos données", title: "Politique de confidentialité", testid: "privacy-page", fallback: buildPrivacyPolicy },
};

export const LegalPage = ({ type }) => {
  const { settings } = useSettings();
  const page = PAGES[type];
  const content = (settings[page.key] || "").trim() || (page.fallback ? page.fallback(settings) : "");

  return (
    <div className="min-h-screen bg-white" data-testid={page.testid}>
      <Header />
      <section className="relative py-24 bg-[#0A0A0A]">
        <div className="container-custom text-center">
          <p className="font-cinzel text-sm uppercase tracking-[0.2em] text-[#D4AF37] mb-4">{page.label}</p>
          <h1 className="font-serif text-4xl md:text-5xl text-white" data-testid={`${page.testid}-title`}>{page.title}</h1>
        </div>
      </section>
      <section className="section-padding">
        <div className="container-custom max-w-4xl">
          {content ? (
            <div className="text-gray-700 leading-relaxed whitespace-pre-line text-base" data-testid={`${page.testid}-content`}>{content}</div>
          ) : (
            <p className="text-gray-500 italic" data-testid={`${page.testid}-empty`}>Ce contenu sera prochainement disponible.</p>
          )}
          <div className="mt-16 pt-8 border-t border-gray-100 text-sm text-gray-500">
            {settings.agency_name} – SIRET 109 512 798 00017 – {settings.address?.replace(/\s*\n\s*/g, ", ")} –{" "}
            <a href={`mailto:${settings.email}`} className="hover:text-[#D4AF37]">{settings.email}</a>
            <span className="mx-3 text-gray-300">|</span>
            <Link to="/" className="hover:text-[#D4AF37]">Retour à l'accueil</Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default LegalPage;
